module.exports = __webpack_public_path__ + "img/Versorgungsstelle_Materialerhaltung.34b93e33.svg";